import { Payable } from '@/types/finance/payable';

const types = ['vendor', 'asset', 'employee', 'payroll', 'maintenance', 'other'] as const;
const statuses = ['pending', 'partial', 'paid', 'overdue', 'cancelled'] as const;

export const payables: Payable[] = Array.from({ length: 50 }, (_, idx) => {
  const id = `payable-${idx + 1}`;
  const createdAt = new Date();
  createdAt.setDate(createdAt.getDate() - Math.floor(Math.random() * 365));
  const dueDate = new Date(createdAt);
  dueDate.setDate(dueDate.getDate() + Math.floor(Math.random() * 90) + 30);
  const updatedAt = new Date(createdAt);
  updatedAt.setDate(updatedAt.getDate() + Math.floor(Math.random() * 30));
  const paidAt = Math.random() > 0.3 ? new Date(createdAt) : undefined;
  if (paidAt) paidAt.setDate(paidAt.getDate() + Math.floor(Math.random() * 30));

  return {
    id,
    name: `Conta a Pagar ${idx + 1}`,
    description: `Descrição da conta a pagar ${idx + 1}`,
    amount: {
      amount: Math.floor(Math.random() * 10000) + 100,
      currency: 'BRL'
    },
    type: types[Math.floor(Math.random() * types.length)],
    status: statuses[Math.floor(Math.random() * statuses.length)],
    dueDate,
    paidAt,
    vendor: {
      id: `vendor-${Math.floor(Math.random() * 20) + 1}`,
      name: `Fornecedor ${Math.floor(Math.random() * 20) + 1}`
    },
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    },
    createdAt,
    updatedAt,
    activityRecords: [
      {
        timestamp: createdAt,
        type: 'created',
        performedBy: { 
          id: 'user-1', 
          name: 'Admin User',
          displayName: 'Admin User'
        }
      },
      {
        timestamp: updatedAt,
        type: 'updated',
        performedBy: { 
          id: 'user-1', 
          name: 'Admin User',
          displayName: 'Admin User'
        },
        details: 'Conta atualizada'
      }
    ]
  };
}); 